import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import './CitationsComponent.scss';

const CitationsComponent = ({ citations }) => {
    return (
        <div className="citations-component">
            {citations.map((citation, index) => (
                <div key={index} className="citation-item">
                    <div className="citation-icon-container">
                        <img src={citation.logo} alt="logo" className="citation-icon" />
                    </div>
                    <div className="citation-content">
                        <h4 className="citation-heading">{citation.title || citation.tile}</h4>
                        <p className="citation-data">{citation.date}</p>
                    </div>
                    <div className="citation-action">
                        <a href={citation.link} target="_blank" rel="noopener noreferrer">
                            <FiExternalLink />
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CitationsComponent;
